<div class="title m-b-10">Type USERNAME of your friend</div>
<form [formGroup]="opponentNameForm" (submit)="startTheGameEvent()">
    <input name="opponentName" class="" type="text"  formControlName="opponentName"/>
</form>

